import React, { useState, createRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

const Scrollbar = ({
  innerRef,
  className,
  settings,
  switcher,
  ...attributes
}) => {
  const [instance, setInstance] = useState();
  const ref = createRef();
  innerRef && innerRef(ref);

  const init = () => {
    if (!instance) {
      createPerfectScrollbar();
    }
  };

  const createPerfectScrollbar = () => {
    setInstance(new PerfectScrollbar(ref.current, settings));
  };

  const unInit = () => {
    if (instance) {
      instance.destroy();
      setInstance(null);
    }
  };

  useEffect(() => {
    switcher ? init() : unInit();
  }, [switcher]); // eslint-disable-line

  useEffect(() => unInit(), []); // eslint-disable-line

  return (
    <div
      className={classNames(className)}
      css={{ position: "relative" }}
      {...attributes}
      ref={ref}
    />
  );
};

Scrollbar.propTypes = {
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  settings: PropTypes.object,
  switcher: PropTypes.bool,
};

export default Scrollbar;
